import { MeetingProvider, Channel } from "./Enums"

// Utility function to convert MeetingProvider into dropdown options
export const meetingProviderOptions = (preferedProvider) => {
    return Object.entries(MeetingProvider).map(([key, value]) => ({
        label: (preferedProvider === value) ? `${key} (prefered)` : key,
        value: value,
        id: `${key}_${value}`
    }))
}

// Utility function to convert Channel into dropdown options
const enumToTrueMap = (enumObj) => {
    const trueMap = {}
    Object.values(enumObj).forEach(value => {
        trueMap[value] = true
    })
    return trueMap
}
export const messageChannelOptions = () => {
    return enumToTrueMap(Channel)
}

// Create a reverse lookup object
const MeetingProviderText = Object.keys(MeetingProvider).reduce((obj, key) => {
    obj[MeetingProvider[key]] = key
    return obj
}, {})

// Function to get the provider name by its integer value
export const getMeetingProviderText = (meetingProviderInt) => {
    return MeetingProviderText[meetingProviderInt] || null
}

// Create a reverse lookup object
const MessageChannelText = Object.keys(Channel).reduce((obj, key) => {
    obj[Channel[key]] = key
    return obj
}, {})

// Function to get the channel name by its integer value
export const getMessageChannelText = (channelInt) => {
    return MessageChannelText[channelInt] || null
}

export const getSelectedChannels = (selectedChannelsMap) => {
    return Object.keys(selectedChannelsMap)
        .filter(c => selectedChannelsMap[c] === true)
        .map(c => parseInt(c))
}